<template>
  <div
    :class="$style.wrapper"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <BaseAvatar
      auto-size
      :url="playerImage"
      :class="[
        !athlete ? $style.noAthlete : null,
        $style.avatar
      ]"
      :class-name="!athlete ? $style.noAthleteImg : null"
      :is-hover="isHover"
      @click="handleClick"
      @onOverlayEnter="handleOverlayVisibility"
      @onOverlayHide="isOverlayShown = false"
    >
      <template
        v-if="athlete"
        v-slot:overlay
      >
        <div @click="handleAthleteDetach({ roundId, athleteId: athlete.id })">
          <font-awesome-icon
            icon="trash-alt"
            size="2x"
          />
        </div>
      </template>
    </BaseAvatar>
    <template v-if="athlete">
      <div :class="$style.athleteName">
        {{ athlete.lastName[$i18n.locale] }}
      </div>
      <div :class="$style.teamName">
        {{ athlete.team.display_name[$i18n.locale] }}
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-center">
        <BaseButton
          font-size="tiny"
          is-rounded
          @click="handleClick"
        >
          <span class="px-0 px-sm-2">{{ $t('pick-a-player') }}</span>
        </BaseButton>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseAvatar from '@/components/Atoms/BaseAvatar'

export default {
  name: 'BasePickAthleteButton',
  components: { BaseAvatar, BaseButton },
  props: {
    roundId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    athlete: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      playerImage: this.athlete && this.athlete.image
        ? this.athlete.image
        : require('@/assets/images/player.svg'),
      playerBackground: require('@/assets/images/playerBack.svg'),
      isHover: false,
      isOverlayShown: false,
    }
  },
  watch: {
    athlete: {
      handler: function({ image } = {}) {
        this.playerImage = image || require('@/assets/images/player.svg')
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      handleOpenAthleteDetail: 'athletes/detail/openAthleteDetail',
      detachAthleteFromRound: 'rounds/assignAthleteIntoRound/detachAthleteFromRound',
    }),
    handleAthleteDetach(params) {
      if (this.isOverlayShown) {
        this.detachAthleteFromRound(params).then(() => {
          this.$emit('onAthletePickRemove', params)
        })
      }
    },
    handleOverlayVisibility() {
      setTimeout(() => {
        this.isOverlayShown = true
      }, 150)
    },
    handleClick() {
      this.$emit('onPlayerAdd')
    },
    handleMouseEnter() {
      this.isHover = true
    },
    handleMouseLeave() {
      this.isHover = false
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";

  .wrapper {
    text-align: center;

    .avatar {
      margin-bottom: 10px;
    }

    .athleteName {
      display: block;
      font-weight: 600;
    }

    .teamName {
      font-size: $font-size-small;
      margin-top: -5px;
    }

    .noAthleteImg {
      background: lighten($color-brainstem-grey, 10);
    }

    .noAthlete {
      cursor: pointer;
      position: relative;

      &:before {
        position: absolute;
        border-radius: 50%;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        content: '';
        box-shadow: inset 0 0 0 5px lighten($color-brainstem-grey, 10);
      }
    }
  }
</style>
